import jQuery from "jquery";
window.jQuery = window.$ = jQuery;

class RegisterHelper {
    constructor(id) {
        this.id = id;
        this.player = null;
        [this.width, this.height] = this.calcVideoSize();

        this.initYouTubePlayer();
    }

    initYouTubePlayer() {
        var tag = document.createElement("script");

        window.onYouTubePlayerAPIReady = () => {
            this.player = new YT.Player(this.id, {
                height: this.height,
                width: this.width,
                videoId: "j30DMtG-Dug",
                playerVars: {
                    playsinline: 1,
                },
                /* events: {
                    onReady: (event) => {
                        event.target.setVolume(100);
                        //event.target.seekTo(190);
                        event.target.playVideo();
                    },
                    onStateChange: (event) => {
                        if (event.data == YT.PlayerState.PLAYING && !registerHelperYouTubePlayerDone) {
                            setTimeout(() => window.player.stopVideo(), 6000);
                            registerHelperYouTubePlayerDone = true;
                        }
                    },
                }, */
            });
        };

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    calcVideoSize() {
        if (window.innerWidth > 1280) {
            let baseWidth = 640;
            let baseHeight = 360;

            var width = (window.innerWidth / 2 / 6) * 5;
            if (width > baseWidth) {
                width = baseWidth;
            }
            let height = (width / baseWidth) * baseHeight;

            return [width, height];
        } else {
            let width = 480;
            let height = 270;

            return [width, height];
        }
    }
}

class ApplicationHelper {
    static data = {
        claimant_name: { from: 0, duration: 17 },
        mother_name: { from: 17, duration: 11 },
        claimant_zip_code: { from: 28, duration: 14 },
        birth_date: { from: 42, duration: 8 },
        building_name: { from: 50, duration: 19 },
        location_same_as_claimant: { from: 69, duration: 29 },
        lot_number: { from: 98, duration: 27 },
        building_type: { from: 125, duration: 34 },
        "older_than_ten_years-1": { from: 159, duration: 36 },
        "older_than_ten_years-0": { from: 159, duration: 36 },
        insulation_year: { from: 195, duration: 10 },
        slab_roof_insulation_year: { from: 205, duration: 9 },
        window_installation_year: { from: 214, duration: 5 },
        heated_area: { from: 219, duration: 33 },
        current_heating_type: { from: 251, duration: 30 },
        heating_model: { from: 282, duration: 93 },
        "public_tender-1": { from: 376, duration: 32 },
        "public_tender-0": { from: 376, duration: 32 },
        "should_catch_sync-1": { from: 408, duration: 37 },
        "should_catch_sync-0": { from: 408, duration: 37 },

        view_coupons: { from: 444, duration: 20 },
        view_state_waiting_for_review: { from: 463, duration: 22 },
        view_state_waiting_for_signature: { from: 484, duration: 69 },
        view_state_waiting_for_order_form: { from: 552, duration: -1 },
    };

    constructor(disabled) {
        this.videoId = "K-_BJxAQaBc";
        this.timeoutId = null;
        this.player = null;
        this.modalPlayer = null;
        this.modalPlayerInitializing = false;
        this.disabled = disabled;
        this.lastFocusedField = null;
        this.videoSeeked = false;

        this.initAutoplayToggle();
        this.initSeekingListeners();
        this.initYouTubePlayer();
    }

    initAutoplayToggle() {
        let toggle = $("#enable-application-player-autoplay-toggle");
        toggle.on("change", (event) => {
            let autoplay = event.target.checked;

            if (!autoplay) {
                this.player.pauseVideo();
            }
        });
    }

    initYouTubePlayer() {
        var tag = document.createElement("script");

        window.onYouTubePlayerAPIReady = () => {
            this.player = new YT.Player("application-player", {
                height: (360 / 640) * 360,
                width: 360,
                videoId: this.videoId,
                playerVars: {
                    playsinline: 1,
                },
                events: {
                    onReady: (event) => {
                        event.target.playVideo();

                        let isModal = false;
                        this.initSeekTo(event.target, isModal);
                    },
                    onStateChange: (event) => {
                        if (event.data == YT.PlayerState.PAUSED) {
                            this.cancelTimeout();
                        }

                        if (
                            this.videoSeeked &&
                            event.data == YT.PlayerState.PLAYING
                        ) {
                            if (!this.getAutoplay()) {
                                this.player.pauseVideo();
                            }

                            this.videoSeeked = false;
                        }
                    },
                },
            });
        };

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    attachModalYoutubePlayer() {
        this.modalPlayerInitializing = true;

        let width = window.innerWidth > 928 ? 848 : window.innerWidth - 5 * 16;
        let height = (360 / 640) * width;

        this.modalPlayer = new YT.Player("application-player-modal", {
            height: height,
            width: width,
            videoId: this.videoId,
            playerVars: {
                playsinline: 1,
            },
            events: {
                onReady: (event) => {
                    event.target.playVideo();

                    let isModal = true;
                    this.initSeekTo(event.target, isModal);
                },
            },
        });
    }

    initSeekingListeners() {
        $(document).on("focus", "input", (e) => {
            if (e.target.type === "search") {
                // search select
                let name = e.target
                    .closest(".choices")
                    .querySelector("select").id;
                this.onFocus(name);
            } else {
                // text
                // checkbox
                // radio
                let name = e.target.id;
                this.onFocus(name);
            }
        });

        $(document).on("focus", "select", (e) => {
            // dropdown select
            let name = e.target.id;
            this.onFocus(name);
        });
    }

    onFocus(name) {
        let data = this.getSeekData(name);
        if (data !== null) {
            this.lastFocusedField = name;
            if (!this.disabled) {
                let isModal = false;
                this.onSeekTo(this.player, data, isModal);
            }
        }
    }

    initSeekTo(player, isModal) {
        if (
            $(".fi-resource-edit-record-page.fi-resource-end-user-applications")
                .length > 0
        ) {
            if (isModal) {
                let data = this.getSeekData(
                    this.lastFocusedField ?? "data.claimant_name"
                );
                if (data !== null) {
                    this.onSeekTo(player, data, isModal);
                }
            } else {
                this.videoSeeked = true;
            }
            return;
        }

        if (
            $(
                ".fi-resource-view-coupons-record-page.fi-resource-end-user-applications"
            ).length > 0
        ) {
            let data = this.getSeekData("data.view_coupons");
            let isModal = false;
            this.onSeekTo(player, data, isModal);
            return;
        }

        if (
            $(
                ".fi-resource-view-state-record-page.fi-resource-end-user-applications"
            ).length > 0
        ) {
            let step = $("#application-status-table").first().data("step");
            var data = null;
            switch (step) {
                case 1:
                    data = this.getSeekData(
                        "data.view_state_waiting_for_review"
                    );
                    break;
                case 2:
                    data = this.getSeekData(
                        "data.view_state_waiting_for_signature"
                    );
                    break;
                default:
                    data = this.getSeekData(
                        "data.view_state_waiting_for_order_form"
                    );
                    break;
            }
            let isModal = false;
            this.onSeekTo(player, data, isModal);
            return;
        }
    }

    onSeekTo(player, data, isModal) {
        let currentTime = player.getCurrentTime();
        let currentState = player.getPlayerState();

        let from = data.from;
        let to = data.from + data.duration;

        // Perform if the video is not within the time interval
        if (
            currentState !== YT.PlayerState.PLAYING ||
            !(from <= currentTime && currentTime <= to)
        ) {
            // Cancel previous setTimeout
            this.cancelTimeout();

            player.seekTo(from, true);
            if (!isModal) {
                this.videoSeeked = true;
            }

            if (this.getAutoplay()) {
                player.playVideo();
                if (data.duration > 0) {
                    this.timeoutId = setTimeout(
                        () => player.pauseVideo(),
                        data.duration * 1000
                    );
                }
            }
        }
    }

    getSeekData(name) {
        let data = ApplicationHelper.data[name.split(".")[1]];
        if (data === undefined) {
            return null;
        } else {
            return data;
        }
    }

    cancelTimeout() {
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }

    getAutoplay() {
        let toggle = $("#enable-application-player-autoplay-toggle");
        return toggle.is(":checked");
    }
}

function isInnerWidthGreaterThan(width) {
    return window.innerWidth <= width;
}

var registerHelper;
var applicationHelper;

const observer = new MutationObserver(() => {
    if ($("#application-player-modal").length > 0) {
        if (!applicationHelper.modalPlayerInitializing) {
            applicationHelper.attachModalYoutubePlayer();
        } else {
            applicationHelper.modalPlayerInitializing = false;
        }
    }
});

window.addEventListener("load", function () {
    if (
        $("#register-player").length > 0 &&
        $("#register-player-mobile").length > 0
    ) {
        registerHelper = isInnerWidthGreaterThan(1280)
            ? new RegisterHelper("register-player-mobile")
            : new RegisterHelper("register-player");
    }

    if ($("#application-player").length > 0) {
        applicationHelper = new ApplicationHelper(
            isInnerWidthGreaterThan(1024)
        );
    }

    if (
        $(".fi-resource-edit-record-page.fi-resource-end-user-applications")
            .length > 0
    ) {
        observer.observe(
            document.querySelector(
                ".fi-resource-edit-record-page.fi-resource-end-user-applications"
            ),
            {
                subtree: true,
                childList: true,
            }
        );
    }

    if (
        $(
            ".fi-resource-view-state-record-page.fi-resource-end-user-applications"
        ).length > 0
    ) {
        observer.observe(
            document.querySelector(
                ".fi-resource-view-state-record-page.fi-resource-end-user-applications"
            ),
            {
                subtree: true,
                childList: true,
            }
        );
    }

    if (
        $(
            ".fi-resource-view-coupons-record-page.fi-resource-end-user-applications"
        ).length > 0
    ) {
        observer.observe(
            document.querySelector(
                ".fi-resource-view-coupons-record-page.fi-resource-end-user-applications"
            ),
            {
                subtree: true,
                childList: true,
            }
        );
    }
});

window.addEventListener("resize", function () {
    if ($("#application-player").length > 0) {
        applicationHelper.disabled = isInnerWidthGreaterThan(1024);
        if (window.innerWidth < 1024) {
            applicationHelper.player?.pauseVideo();
        }
    }

    if ($("#register-player").length > 0) {
        if (window.innerWidth > 1280) {
            var width, height;
            [width, height] = registerHelper.calcVideoSize();

            registerHelper.player?.setSize(width, height);
        }
    }
});
